import { NatureProduitCrm } from './natureProduitCrm';

export class NatureProduitCrmDocument {
         id: number | undefined;
         code: string;
         libelle: string;
         obligatoire: boolean;
         natureProduitCrm: NatureProduitCrm;
         typeDocumentProduitCrmId: number;
         selected: boolean;
       }
